<template>
  <div>
    <div class="animated fadeIn">
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        :is-full-page="false"
        :v-on:update:title="isLoading = false"
      />
    </div>
    <horizontal-stepper
      locale="pt"
      v-if="steps != null"
      :steps="steps"
      :keep-alive="false"
      :reset="true"
      @stepper-finished="finalizar"
      @completed-step="completeStep"
      @active-step="isStepActive"
    />
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";

import axios from "axios";
import * as config from "@/config.json";
import HorizontalStepper from "@/horizontal-stepper";

// Steps
import VincularSorteio from "./steps/1_VincularSorteio";
import ImagemSorteio from "./steps/2_ImagemSorteio";
import ConfigurarSorteio from "./steps/3_ConfigurarSorteio";

export default {
  name: "inserir-promocoes",
  filters: {
    translate: function(value, locale) {
      return translations[locale][value];
    }
  },
  components: {
    Loading,
    HorizontalStepper,
    VincularSorteio,
    ImagemSorteio,
    ConfigurarSorteio
  },
  data: function() {
    return {
      isLoading: false,
      titulo: null,
      descricao: null,
      isjornalzinho: null,
      steps: [
        {
          icon: "assignment",
          name: "vincular-sorteio",
          title: "Vincular Sorteio",
          component: VincularSorteio
        },
        {
          icon: "photo",
          name: "vincular-imagem",
          title: "Vincular Imagem",
          component: ImagemSorteio
        },
        {
          icon: "check_box",
          name: "finalizar",
          title: "Finalizar",
          component: ConfigurarSorteio
        }
      ]
    };
  },
  watch: {},
  methods: {
    rowHandler(record, index) {
      localStorage.setItem("cod_promocao", record.codigo);
      localStorage.setItem("data_inicial", record.data_inicial);
      localStorage.setItem("data_final", record.data_final);
      this.$router.push({ path: `inserir-promocao/${record.codigo}` });
    },
    goBack() {
      this.$router.go(-1);
    },
    cancelLoading() {
      this.isLoading = false;
    },
    // Executed when @completed-step event is triggered
    completeStep(payload) {
      this.isLoading = true;
      this.steps.forEach(step => {
        if (step.name === payload.name) {
          step.completed = true;
        }
      });
    },
    // Executed when @active-step event is triggered
    isStepActive(payload) {
      this.steps.forEach(step => {
        if (step.name === payload.name) {
          if (step.completed === true) {
            step.completed = false;
          }
        }
      });
    },
    removeImagens() {
      for (let i = 1; i < 10; i++) {
        localStorage.removeItem(`image-${i}`);
      }
    },
    limpaLocalStorage() {
      localStorage.removeItem("image");
      localStorage.removeItem("selecionado");
      localStorage.removeItem("titulo");
      localStorage.removeItem("descricao");
      localStorage.removeItem("data_inicial");
      localStorage.removeItem("data_final");
    },
    async finalizar(value) {
      this.isLoading = true;
      var havepush = localStorage.getItem("have-push");
      await axios
        .put(
          `${config.default.servidor}/gerencial/sorteio`,
          {
            empresaid: localStorage.getItem("enterprise_id"),
            sorteioid_local: localStorage.getItem("selecionado"),
            titulo: localStorage.getItem("titulo"),
            descricao: localStorage.getItem("descricao"),
            imagem: localStorage.getItem("image"),
            data_inicial: localStorage.getItem("data_inicial"),
            data_final: localStorage.getItem("data_final")
          },
          {
            headers: {
              Accept: "application/json",
              Authorization: "Basic c2E6QURNQUNDRVNZUw=="
            }
          }
        )
        .then(response => {
          if (response.status == 200) {
            let toast = this.$toasted.show("Sucesso!", {
              theme: "toasted-primary",
              position: "bottom-center",
              duration: 5000,
              icon: "check",
              iconPack: "fontawesome"
            });
            if (havepush == "true")
              localStorage.setItem("redirectid", response.data.sorteioid);
          } else {
            let toast = this.$toasted.show("Algo deu errado.", {
              theme: "toasted-primary",
              position: "bottom-center",
              duration: 5000,
              icon: "times",
              iconPack: "fontawesome"
            });
            this.$router.push({ path: `/sorteios` });
          }
        });
      if (havepush == "true") {
        localStorage.setItem("tipoid", "3");
        this.$router.push({ path: `/cadastrar-campanha` });
      } else {
        this.$router.push({ path: `/sorteios` });
      }
      this.isLoading = false;
      this.limpaLocalStorage();
    }
  },
  beforeMount() {
    this.isLoading = true;
    this.isLoading = false;
  }
};
</script>